import { defineTheme } from '../contracts.js';
export const win98 = defineTheme({
    id: 'win98',
    displayName: 'Win98',
    lifecycle: 'ready',
    selectable: true,
    implementation: 'legacy',
    extensionThemeId: 'windows95',
    capabilities: {
        alerts: 'available',
        welcomes: 'available',
        wam: 'external',
        startup: 'external',
        achievements: 'unsupported',
        viewerSounds: 'external',
        privateChatSounds: 'unsupported',
    },
});
//# sourceMappingURL=registration.js.map